import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const sparkPost = defineConnector({
  identifier: "sparkPost",
  name: "SparkPost",
  tagLine: "Email delivery and analytics",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://api(\\.eu)?\\.sparkpost\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Select your SparkPost region",
      items: [
        {
          kind: "select",
          label: "Region",
          required: true,
          target: { kind: "configuration", field: "host" },
          options: [
            { value: "api.sparkpost.com", label: "US (api.sparkpost.com)" },
            {
              value: "api.eu.sparkpost.com",
              label: "EU (api.eu.sparkpost.com)",
            },
          ],
          defaultValue: "api.sparkpost.com",
        },
      ],
    },
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content: ({ host }: Record<string, string>) => {
            const keysLink = host
              ? `[API keys page](https://${host.replace("api.", "app.")}/account/api-keys)`
              : "**Account > API Keys** page";
            return `Visit the ${keysLink} in SparkPost and create a new API key with the permissions you need.`;
          },
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "SparkPost API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/api/v1/account`,
  },
});
